
<section class="content">
  <div class="card" style="padding:25px">
    <div class="container-fluid">
      <div class="row">
        <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
          {{title}}
        </div>
      </div>

      <div class="row">
        <div class="col-3">
          <label for="exampleFormControlSelect1"> Select Employee Type <i class="material-icons"
            style="color: red;font-size: 14px;">star</i></label>
          <mat-select [(ngModel)]="customer_type_id" [disabled]="is_disabled_get" class="main-border-class">
            <mat-option *ngFor="let customer_type of customer_type_list" [value]="customer_type.customer_type_id">{{customer_type.name}}</mat-option>
          </mat-select>
        </div>

        <div class="col-2">
          <button  [disabled]="is_disabled_get" (click)="getClicked()" style="font-size: 27px;margin-top: 15%;border-radius: 5px;background: blanchedalmond;">GET</button>
        </div>

        <div *ngIf="this_order_is_placed == false" class="col-7">
          <button [disabled]="is_disabled" (click)="orderClicked()" style="font-size: 27px;margin-left: 77%;border-radius: 5px;background: rgb(9, 214, 71); color: black;">Place an Order</button>
        </div>

        <div *ngIf="this_order_is_placed == true" class="col" style="font-size: 25px; color: red;">
          {{worning_content}}
        </div>

      </div>
      <br>
    </div>
  </div>

  <div class="row">
    <div class="col-4" *ngIf="is_loaded == false" >
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="50">
      </mat-progress-spinner>
    </div>
  </div>

  <div *ngIf="this_order_is_placed == null || this_order_is_placed == false" class="col" style="font-size: 25px; color: rgb(36, 110, 18);">
    <h1>Order for Month {{monthNames[next_month]}} - {{next_year}}.</h1>
  </div>

  <div *ngIf="this_order_is_placed == false" class="card" style="padding:25px">
    <div class="container-fluid">
      <div class='row'>
        <table class="table table-bordered">
          <thead style="text-align: center;">
            <th>Sl.No</th>
            <th>Employee Code</th>
            <th>Employee Name</th>
            <th>Employee Union</th>
            <th>Booth Code</th>
            <th>Product</th>
            <th>Quantity</th>
            <th>Delete</th>
          </thead>
          <tbody>
            <tr *ngFor="let employee_order of employee_order_list; let data_index=index">

              <td style="text-align: center;">{{data_index+1}}</td>

              <td style="text-align: center;">{{employee_order.employee_code}}</td>

              <td>{{employee_order.name}}</td>

              <td style="text-align: center;">{{employee_order.union}}</td>

              <td (click)="openDialog('booth_code', data_index, employee_order)" style="text-align: center;">{{employee_order.booth_code}}
                  <span style="font-size: 16px;" class="material-icons">
                    create
                  </span>
              </td>

              <td (click)="openDialog('product', data_index, employee_order)" style="text-align: center;">{{employee_order.product}}
                <span style="font-size: 16px;" class="material-icons">
                    create
                </span>
              </td>

              <td (click)="openDialog('quantity', data_index, employee_order)" style="text-align: center;">{{employee_order.quantity}}
                <span style="font-size: 16px;" class="material-icons">
                    create
                </span>
              </td>

              <td style="text-align: center;" >
                <button mat-button (click)="removeItem(data_index)">

                  <span style="font-size: 24px; color: red;" class="material-icons">
                    delete_forever
                  </span>

                </button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div *ngIf="this_order_is_placed == true" class="card" style="padding:25px">
    <div class="container-fluid">
      <div>
        <h1> Order for Month {{monthNames[next_month]}} - {{next_year}} is successfuly placed.</h1>
      </div>
    </div>
  </div>

</section>
